import { Button, ButtonWithPopOut } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { capitalize } from "@s-libs/micro-dash";

import {
  buttonContainerCss,
  buttonWithPopoutCss,
  getSortByButtonOptionCss,
  popoutContainerCss,
  selectedOptionIndicatorCss,
} from "@/search/Langston/ContentTypeFilter/ContentHeaderSortByButton/ContentHeaderSortByButton.styles";
import { useSearchPageContext } from "@/search/Langston/SearchPageProvider";

import { LangstonParameterSchema } from "@/search/Langston/LangstonParameterSchema";

const sortByFilterOptions = LangstonParameterSchema.sort.values;
const defaultSortByOption = LangstonParameterSchema.sort.default;

const ButtonWithTrackEvent = withTrackEvent(Button);

const ContentHeaderSortByButton = () => {
  const {
    handlers: {
      getSearchParamValues,
      setSearchParamValue,
      hasSearchParamValue,
    },
  } = useSearchPageContext();

  const selectedSortByValue =
    getSearchParamValues(LangstonParameterSchema.sort.key)?.[0] ||
    defaultSortByOption;
  const selectedSortByLabel = sortByFilterOptions.find(
    (option) => option.value === selectedSortByValue,
  )?.label;
  const capitalizedLabel =
    selectedSortByLabel &&
    selectedSortByLabel
      .split(" ")
      .map((word) => capitalize(word))
      .join(" ");

  return (
    <ButtonWithPopOut
      id="search-sort-by-header-button"
      closeOnBlur
      __cssFor={buttonWithPopoutCss}
      horizontalOffset="0px"
      verticalOffset="6px"
      buttonContents={`Sort by ${capitalizedLabel}`}
      popOutContents={
        <div css={popoutContainerCss}>
          {sortByFilterOptions.map((option) => {
            const isSelected = hasSearchParamValue(
              LangstonParameterSchema.sort.key,
              option.value,
            );

            return (
              <div key={option.value} css={buttonContainerCss}>
                {isSelected && <div css={selectedOptionIndicatorCss} />}

                <ButtonWithTrackEvent
                  dataProps={{
                    "data-qa-selector": `search-${LangstonParameterSchema.sort.key}-filter-option`,
                  }}
                  objectType={objectTypes.content}
                  actionName={actionNames.filter}
                  flavor={Button.flavors.incognito}
                  onClick={() =>
                    setSearchParamValue(
                      LangstonParameterSchema.sort.key,
                      option.value,
                    )
                  }
                  __cssFor={getSortByButtonOptionCss(isSelected)}
                >
                  {option.label}
                </ButtonWithTrackEvent>
              </div>
            );
          })}
        </div>
      }
    />
  );
};

ContentHeaderSortByButton.displayName = "Co40pxtentHeaderSortByButton";
export { ContentHeaderSortByButton };
